import type { TimeframeOption } from "@/types";
import { startOfMonth, sub } from "date-fns";
import { type ReactNode, createContext, useContext, useState } from "react";

type Unit = "kWh" | "Euro";

interface ConsumptionContextType {
	selectedDate: Date;
	setSelectedDate: (date: Date) => void;
	timeframe: TimeframeOption;
	setTimeframe: (t: TimeframeOption) => void;
	unit: Unit;
	setUnit: (u: Unit) => void;
}

const ConsumptionContext = createContext<ConsumptionContextType | undefined>(
	undefined,
);

export const ConsumptionProvider = ({ children }: { children: ReactNode }) => {
	const today = new Date();
	const [selectedDate, setSelectedDate] = useState<Date>(
		today.getDate() <= 5
			? startOfMonth(sub(today, { months: 1 }))
			: startOfMonth(today),
	);
	const [timeframe, setTimeframe] = useState<TimeframeOption>("Monthly");
	const [unit, setUnit] = useState<Unit>("kWh");

	return (
		<ConsumptionContext.Provider
			value={{
				selectedDate,
				setSelectedDate,
				timeframe,
				setTimeframe,
				unit,
				setUnit,
			}}
		>
			{children}
		</ConsumptionContext.Provider>
	);
};

export const useConsumption = () => {
	const context = useContext(ConsumptionContext);
	if (!context)
		throw new Error("useConsumption must be used within a ConsumptionProvider");
	return context;
};
